import React from 'react'
import { Button, Tooltip } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import IconComponent from '../icon-component'

const IconSelect = ({
  iconList,
  value,
  onChange,
}: {
  iconList: string[]
  value?: string
  onChange?: (value: string | undefined) => void
}) => {
  const renderIcon = (iconName: string) => {
    const isActive = iconName === value
    return (
      <Tooltip key={iconName} title={iconName} placement="top">
        <div
          onClick={() => onChange?.(iconName)}
          style={{
            width: 40,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 6,
            cursor: 'pointer',
            border: isActive ? '2px solid #1677ff' : '2px solid transparent',
            background: isActive ? '#e6f4ff' : 'transparent',
            transition: 'all 0.15s',
            flexShrink: 0,
          }}
        >
          <IconComponent iconName={iconName} />
        </div>
      </Tooltip>
    )
  }

  return (
    <div style={{ border: '1px solid #d9d9d9', borderRadius: 8, padding: 8, background: '#fafafa' }}>
      {value && (
        <div style={{ marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 12, color: '#888' }}>Выбрано:</span>
          {renderIcon(value)}
          <Button
            size="small"
            type="text"
            icon={<CloseOutlined />}
            onClick={() => onChange?.(undefined)}
            title="Очистить"
            style={{ marginLeft: 'auto', color: '#888' }}
          />
        </div>
      )}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 4,
          maxHeight: 200,
          overflowY: 'auto',
          paddingRight: 4,
        }}
      >
        {iconList.map(renderIcon)}
      </div>
    </div>
  )
}

export default IconSelect
